import { QuoteCard } from '@/components/quotes/QuoteCard'
import { type QuoteCardData, QuoteCardStage } from '@/components/quotes/quoteCardTypes'
import { Cap } from '../../primitives'
import { describeQuote } from './quoteCardData'

const noop = () => undefined

/** One labelled state: expanded on the left, summary on the right when there is one. */
export function Row({
  label,
  expanded,
  summary,
}: {
  label: string
  expanded: React.ReactNode
  summary?: React.ReactNode
}) {
  return (
    <div className="flex flex-col gap-2">
      <Cap>{label}</Cap>
      {summary && (
        <div className="hidden gap-4 lg:grid lg:grid-cols-2">
          <Cap>Expanded</Cap>
          <Cap>Summary — onCardClick</Cap>
        </div>
      )}
      <div className="grid items-start gap-4 lg:grid-cols-2">
        <div>{expanded}</div>
        {summary && <div>{summary}</div>}
      </div>
    </div>
  )
}

/** Keeps a full-width child in the left column, so it isn't stretched to both. */
export function Cell({ children }: { children: React.ReactNode }) {
  return <div className="grid gap-4 lg:grid-cols-2">{children}</div>
}

/** Expanded on the left, summary on the right once priced — the handlers production passes. */
export function QuoteRow({ quote }: { quote: QuoteCardData }) {
  return (
    <Row
      label={describeQuote(quote)}
      // Summary only differs once priced — minimal states ignore onCardClick.
      summary={
        quote.stage === QuoteCardStage.PRICED ? (
          <QuoteCard quote={quote} onCardClick={noop} onReviewAttestation={noop} onUploadDocument={noop} />
        ) : undefined
      }
      expanded={<QuoteCard quote={quote} onReviewAttestation={noop} onUploadDocument={noop} />}
    />
  )
}
